import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { NgSelectModule } from "@ng-select/ng-select";
import { TranslatePipe } from "./pipe/translation.filter.pipe";
import { CanDirective } from "./directives/can.directive";


@NgModule({
  declarations: [
    TranslatePipe,
    // `*appCan="AppActions.X"`: mostra un blocco solo se l'azione è permessa a questo utente.
    // È esportata da qui perché serve ovunque, dalle pagine ai singoli campi di un form.
    CanDirective
  ],
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule,
    RouterModule,
    ReactiveFormsModule
  ],
  exports: [
    TranslatePipe,
    CanDirective
  ],
  providers: []
})
export class SharedModule { }
